module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = rowResourceData || {}\nconst attributes = data.attributes || {}\nconst terms = attributes.terms || []\n%><div><%\nfor(const term of terms){\nlet dateFormatted = ''\nif(term.startTS){\ndateFormatted = utils.moment(term.startTS).format('DD.MM.YYYY')\n}\nconst people = []\nfor(const job of term.jobs || []){\nif(job.employee){\nconst name = job.employee.nickname || job.employee.firstname\nif(name){\npeople.push(name)\n}\n} else if((job.contractor || {}).companyName){\npeople.push(job.contractor.companyName)\n}\n}\n%><div class=\"element\" title=\"<%= term.title %>\"><%\n%><div class=\"title\">#<%= term.projectTermID %> - <%= term.title %></div><%\n%><div class=\"ts\"><%= dateFormatted %><i class=\"<%= term.catering ? 'fi fi-catering' : '' %>\"></i></div><%\n%><%= people.join(', ')%><%\n%></div><%\n}\n%></div>"
  , __filename = "components/templates/office/projects/tableFields/terms.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = rowResourceData || {}
const attributes = data.attributes || {}
const terms = attributes.terms || []

    ; __line = 5
    ; __append("<div>")
    ; 
for(const term of terms){
let dateFormatted = ''
if(term.startTS){
dateFormatted = utils.moment(term.startTS).format('DD.MM.YYYY')
}
const people = []
for(const job of term.jobs || []){
if(job.employee){
const name = job.employee.nickname || job.employee.firstname
if(name){
people.push(name)
}
} else if((job.contractor || {}).companyName){
people.push(job.contractor.companyName)
}
}

    ; __line = 22
    ; __append("<div class=\"element\" title=\"")
    ; __append(escapeFn( term.title ))
    ; __append("\">")
    ; 

    ; __line = 23
    ; __append("<div class=\"title\">#")
    ; __append(escapeFn( term.projectTermID ))
    ; __append(" - ")
    ; __append(escapeFn( term.title ))
    ; __append("</div>")
    ; 

    ; __line = 24
    ; __append("<div class=\"ts\">")
    ; __append(escapeFn( dateFormatted ))
    ; __append("<i class=\"")
    ; __append(escapeFn( term.catering ? 'fi fi-catering' : '' ))
    ; __append("\"></i></div>")
    ; 

    ; __line = 25
    ; __append(escapeFn( people.join(', ')))
    ; 

    ; __line = 26
    ; __append("</div>")
    ; 
}

    ; __line = 28
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/office/projects/tableFields/terms.ejs

}